export const grenoblePostalCode: string[] = [
  '38320',
  '38320',
  '38560',
  '38800',
  '38640',
  '38700',
  '38420',
  '38130',
  '38320',
  '38600',
  '38120',
  '38610',
  '38000',
  '38450',
  '38320',
  '38560',
  '38240',
  '38450',
  '38120',
  '38220',
  '38420',
  '38450',
  '38220',
  '38360',
  '38320',
  '38800',
  '38120',
  '38950',
  '38220',
  '38120',
  '38100',
  '38450',
  '38400',
  '38950',
  '38760',
  '38220',
  '38700',
  '38700',
  '38360',
  '38220',
  '38170',
  '38180',
  '38700',
  '38760',
  '38410',
  '38410',
  '38610',
  '38113'
];
